import { notification, Form, Row, Button, Col, Input } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { login } from '../../utils/APIUtils';
import { getMyCurrentMgCompany } from 'services/parametersService';
import { AuthContext } from '../Auth/Auth';
import './style.css';
import { useForm } from 'antd/lib/form/Form';
import { useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router';
//import ReCAPTCHA from 'react-google-recaptcha';
import React from 'react';
import getEnvValue from 'utils/getEnvValue';
// import comp from '../../assets/';
const FormItem = Form.Item;

const Login = () => {
  const history = useHistory();

  const importAll = (r: any) => {
    let images: any = {};
    r.keys().forEach((item: any, index: any) => {
      images[item.replace('./', '')] = r(item);
    });
    return images;
  };

  const images: any = importAll(
    require.context('../../assets/', false, /\.(png|jpg|jpe?g|svg)$/)
  );

  const captchaRef: any = useRef(null);
  const [form] = useForm();
  const tokenContext = useContext(AuthContext);
  const [iscaptchaRef, setiscaptchRef] = useState(false);

  const handleSubmit = async () => {
    const loginRequest = form.getFieldsValue();

    await login(loginRequest)
      .then(async (response) => {
        localStorage.setItem('userid', response.data?.id);
        localStorage.setItem('username', response.data?.username);
        localStorage.setItem('name', response.data?.name);
        localStorage.setItem('surname', response.data?.surname);
        localStorage.setItem('email', response.data?.email);
        localStorage.setItem('lancode', response.data?.lancode);
        localStorage.setItem('mgid', response.data?.mgid);
        localStorage.setItem('userrole', response.data?.userrole);
        localStorage.setItem('phone', response.data?.phone);
        localStorage.setItem('mobile', response.data?.mobile);
        localStorage.setItem('tabposition', response.data?.tabposition);
        localStorage.setItem('changepassword', response.data?.changepassword);
        localStorage.setItem('usertype', response.data?.usertype);
        localStorage.setItem('theme', JSON.stringify(response.data?.theme));
        localStorage.setItem('logo', response.data?.theme?.logo);
        localStorage.setItem('tpid', response.data?.tpid);
        localStorage.setItem('tprole', response.data?.tprole);
        localStorage.setItem('currcode', response.data?.currcode);
        

        if (response.code === 601) {
          localStorage.setItem('sessionExpiration', JSON.stringify(response));
        }

        tokenContext.setToken(response?.token);
        
        if (response.data?.changepassword === true && response.token) {
          history.push('/init_change_password');
        } else if (response.data?.route) {
          history.push(response.data.route);
        }

       
        if (response.code !== 401) {
          await getMyCurrentMgCompany().then((resp) => {
            localStorage.setItem('mgname', resp.data?.mgname);
          });
        }
        if (response.code === 401) {
          notification.error({ message: response.message });
        } else {
          const code = response.message.includes('msgid:601');
          code ? localStorage.setItem('sessionExpirationMessage', response.message) : localStorage.setItem('sessionExpirationMessage', '');

          if (response.data?.lancode === 'FR') {
            notification.success({
              message: `Bienvenue ${response.data?.surname} ${response.data?.name}`,
              // description: ' !',
              duration: 5,
            });
          } else {
            notification.success({
              message: `Welcome ${response.data?.surname} ${response.data?.name}`,
              description: 'Enjoy your session !',
              duration: 5,
            });
          }

          let message = response.message;
          message = message.replace(/\(msgid:\d+\)/, '');

          message !== 'Authenticated with success' &&
            notification.warn({
              message: message,
              duration: 15,
            });
          
          
          window.location.assign(response.data.route);
        }
      })
      .catch((error) => {
        notification.error({
          message: error.status,
          description: `${error.message}Enable to get your profile. Please try again!`,
        });
        localStorage.removeItem('changepassword');
        localStorage.removeItem('token');
        localStorage.clear();
        history.push('/login');
      });
  };

  return (
    <div className="login-container">
      {/* <div className="login-content">
        <Card
          title="UTINA PLATFORM"
          size="small"
          className={styles.loginCard}
          bordered
        >
            <Row justify="center">
              <Col span={10}>
                <img src={comp} alt="" style={{ width: 200 }} />
              </Col>

              <Col span={8}>
                <Card
                  title="Please enter your username and password :"
                  bordered
                  style={{ width: 350 }}
                >

                </Card>
              </Col>
              <Col span={2}></Col>
            </Row>
          
        </Card>
      </div> */}

      <div className="container">
        <div className="content first-content">
          <div
            className="first-column"
            style={{
              display: ' flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: getEnvValue('primarycolor') + '!important',
              alignContent: 'center',
              textAlign: 'center',
              width: '50%',
              zIndex: 10,
              height: ' 100%',
            }}
          >
            <img
              src={images[getEnvValue('logo2')]}
              alt=""
              style={{ width: 200 }}
            />
            {getEnvValue('platformetext') && (
              <h2 style={{ marginTop: '5px', color: 'white' }}>
                Modern Financial <br /> Solutions
              </h2>
            )}
          </div>
          <div className="second-column">
            <h1
              className="title"
              style={{ color: getEnvValue('primarycolor') }}
            >
              Login
            </h1>
            <p className="description description-second">
              Please enter your username and password :
            </p>
            <Form form={form} onFinish={handleSubmit} className="LoginForm">
              <Row>
                <Col span={24}>
                  <FormItem name="username">
                    <Input
                      prefix={<UserOutlined />}
                      size="large"
                      placeholder="Username"
                    />
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <FormItem name="password">
                    <Input.Password
                      prefix={<LockOutlined />}
                      size="large"
                      type="password"
                      placeholder="Password"
                    />
                  </FormItem>
                </Col>
              </Row>
              <Row>
                {/* <ReCAPTCHA
                  sitekey="6LfSp28jAAAAALZMIqTsPGDGtBiUyHXRvBuOp6wK"
                  ref={captchaRef}
                  onChange={() => {
                      setiscaptchRef(captchaRef.current.getValue());
                  }}
                /> */}
              </Row>
              <Row>
                {/* {iscaptchaRef && ( */}
                <FormItem>
                  <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    // className="login-form-button"
                    style={{
                      width: '300px',
                      backgroundColor: getEnvValue('primarycolor'),
                    }}
                  >
                    Login
                  </Button>
                </FormItem>
                {/* )} */}
              </Row>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
